const restApis ={
    treeParents:"/rest/account/parents?id=",
    userinfo: '/rest/account?id=',
    searchUrl: '/rest/account/brief/list?length=5&content=',
    treeUrl: '/rest/account/subtree',
    allParentUrl: '/rest/account/parents?id=',
    deepToRootUrl: '/rest/account/subtree',
    provinceUrl: '/rest/common/city/province',
    cityUrl: '/rest/common/city',
    //分割线
    login:"/mic/login",
    logout:"/mic/logout",
    globalEnums:"/mic/common/enums",
    vinTypeCount:"/mic/car-model/count",
    vinTypeList:"/mic/car-model/list",
    switchVinTypeListItemStatus:"/mic/car-model/change-status",
    delAddEditVinTypeItem:"/mic/car-model",
    getVinTypeFAllParams: "/mic/car-model/fields-definition",
    //设备列表
    deviceSearch:"/mic/car/select-car",
    deviceCount:"/mic/device/count",
    deviceList:"/mic/device/list",
    addDelDetailDevice:"/mic/device",
    batchModifyDevicesTpls:"/mic/device/batch-modify/template",
    batchModify:"/mic/device/batch-modify",
    osspolicy:"/mic/policy",
    deviceTypes:"/mic/device-type/list",
    deviceLifeCycle:"/mic/opt-log/list",
    avilableDeive:"/mic/device/uninstall",
    //工况
    realWorkingConditions:"/mic/car-data/realtime",
    hisCount:"/mic/car-data/count",
    hisList:"/mic/car-data/list",
    hisDetailDel:"/mic/car-data",
    addressDetail:"/mic/geo/address",
    //车辆
    vinCount:"/mic/car/count",
    vinList:"/mic/car/list",
    globalSearch:"/mic/car/global-search",
    vinDetailDelAdd:"/mic/car",
    batchAddVinsTpls:"/mic/car/batch-add/template",
    batchAddVins:"/mic/car/batch-add",
    vinModelList:"/mic/car-model/support-car-model",
    vinImeilog:"/mic/opt-log/list",
    vinTransfer:"/mic/car/transfer",
    vinTransferCheck:"/mic/car/transfer/check",
    downloadVinList:"",

    //任务
    exportTaskCount:"/mic/export/count",
    exportTaskList:"/mic/export/list",
    taskRetry:"/mic/export/retry",
    createTask:"/mic/export/create-task",
    taskCallback:"/mic/export/callback",
    delExportTask:"/mic/export/delete",
    //指令
    cmdTpls:"/mic/cmd/template",
    sendCmd:"/mic/cmd/template-send",
    calCmd:"/mic/cmd/cancel",
    cmdCount:"/mic/cmd/count",
    cmdList:"/mic/cmd/list",
    addModifyDelDetailCmd:"/mic/cmd",

    //统计
    workTimeList:"/mic/work-data/list",
    accStatisticsList:"/mic/acc-data/list",
    accStatisticsSummaryList:"/mic/acc-data/statistic-list",
    accStatisticsSummaryCount:"/mic/acc-data/statistic-list/count",
    pageableSelectCarList:"/mic/car/pageable-select-car-list",
    runStatisticsList:"/mic/run-statistic/list",
    runStatisticsCount:"/mic/run-statistic/count",
    runStatisticsWorkDetailCount:"/mic/run-statistic/work-detail/count",
    runStatisticsWorkDetailList:"/mic/run-statistic/work-detail",
    alarmSummaryList:"/mic/alarm-statistic/list",
    alarmSummaryCount:"/mic/alarm-statistic/count",
    alarmDetailList:"/mic/alarm-record/list",
    alarmDetailCount:"/mic/alarm-record/count",
    forkliftStatisticsSummaryList:"/mic/forklift-fault-statistic/list",
    forkliftStatisticsSummaryCount:"/mic/forklift-fault-statistic/count",
    forkliftStatisticsDetailList:"/mic/forklift-fault/list",
    forkliftStatisticsDetailCount:"/mic/forklift-fault/count",
    failureStatisticsSummaryList:"/mic/fault-statistic/list",
    failureStatisticsSummaryCount:"/mic/fault-statistic/count",
    failureStatisticsDetailList:"/mic/fault/list",
    failureStatisticsDetailCount:"/mic/fault/count",
    alarmHandle:"/mic/alarm-record/handle",
    alarmNo:"/mic/alarm-record/num",
    engineList:"/mic/engine-work-data/list",
    engineCount:"/mic/engine-work-data/count",
    alarmFence:"/mic/alarm-record/fence-alarm-detail",

    //树
    searchTreeUrl:"/mic/organization/tree/search?length=20&content=",//模糊搜索
    searchUrlBrief:"/mic/organization/tree/search",
    allParents:"/mic/organization/list/parents?orgId=",
    expandTree:"/mic/organization/tree/parents?orgId=",
    exceptTree:"/mic/organization/except/tree?exceptOrgId=",
    loadTreeUrl:"/mic/organization/tree",

    //门店配置
    orgConfig:"/mic/cnf",
    accountInfo:"/mic/customer/current",
    savePermissionConfig:"/mic/permission/config",
    permissionCount:"/mic/permission/count?orgId=",
    permissionList:"/mic/permission/list?orgId=",
    delPermissionConfigItem:"/mic/permission/config?userId=",
    getPermissonsByAccount:"/mic/permission/tree?orgId=",
    getAccountList:"/mic/user/list?orgId=",
    editSwitch:"/mic/permission/status",
    //单位
    distanceUnit:"/mic/cnf/distance-unit",

    //围栏
    fenceList:"/mic/fence/query",
    addDelModifyViewFence:"/mic/fence",
    delFenceCheck:"/mic/fence/del-check",
    imeiFences:"/mic/fence/device-fences",
    byCarFenceCount:"/mic/fence/related-by-car/count",
    byCarFenceList:"/mic/fence/related-by-car/list",
    byOrgFencesCount:"/mic/fence/related-by-org/count",
    byOrgFencesList:"/mic/fence/related-by-org/list",
    bathSingleRelate:"/mic/fence/relate",

    //距离单位
    getDistanceUnit:"/mic/cnf/distance-unit"

}
export default restApis;
